import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';



class OpticsFormulas extends React.Component{

  render(){
    return(
      <MuiThemeProvider>

        <div style = {{paddingBottom: 40}}>

        <Table>
    <TableHeader>
      <TableRow>
        <TableHeaderColumn style = {{width: 450}}>Uses</TableHeaderColumn>
        <TableHeaderColumn>Formula</TableHeaderColumn>
      </TableRow>
    </TableHeader>
    <TableBody>
      <TableRow>
        <TableRowColumn style = {{width: 410}}>Optics Equation</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100, width: 300, height: 70}} src = {require("./Formulas/1.png")} /> </TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 410}}>Magnification</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100, width: 300, height: 70}} src = {require("./Formulas/2.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 410}}>Index of Refraction</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100, width: 300, height: 70}} src = {require("./Formulas/3.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 410}}>Snell’s Law</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100, width: 300, height: 70}} src = {require("./Formulas/4.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 410}}>Power</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100, width: 300, height: 70}} src = {require("./Formulas/5.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 410}}>Multiple Lens (focal length)</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100, width: 300, height: 70}} src = {require("./Formulas/6.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 410}}>Multiple Lens (power)</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100, width: 300, height: 70}} src = {require("./Formulas/7.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 410}}>Multiple Lens (magnification)</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100, width: 300, height: 70}} src = {require("./Formulas/8.png")} /></TableRowColumn>
      </TableRow>
    </TableBody>
  </Table>

</div>


      </MuiThemeProvider>

    );
  }
}

export default OpticsFormulas;



// WEBPACK FOOTER //
// ./src/Physics/Optics/OpticsFormulas.js